<div echarts [options]="options" class="demo-chart"></div>
